/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to delete this item?',
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    // var dropzone = new Dropzone("#dropzone", {url: "/file/post"});
    let start_time = $('.datetimepicker_start');
    let end_time = $('.datetimepicker_end');
    let booking_end_time = $('.datetimepicker_booking_end_time');

    if (booking_end_time.length) {
        // Determine end of the month based on current start_time value (if any), otherwise today
        let refDate = new Date();
        if (start_time.length && start_time.val()) {
            const parsed = new Date(start_time.val());
            if (!isNaN(parsed.getTime())) {
                refDate = parsed;
            }
        }
        const initialEndOfMonth = new Date(refDate.getFullYear(), refDate.getMonth() + 1, 0);

        booking_end_time.flatpickr({
            enableTime: false,
            dateFormat: "Y-m-d",
            allowInput: false,
            minDate: "today",
            startDate: "today",
            maxDate: initialEndOfMonth, // cuối tháng của start_time (hoặc hôm nay nếu chưa chọn)
        });
    }
    if (start_time.length) {
        start_time.flatpickr({
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            minDate: "today",
            allowInput: true,
            onChange: function(selectedDate) {
                
                if (end_time.length) {
                    end_time.flatpickr({
                        enableTime: true,
                        dateFormat: "Y-m-d H:i",
                        allowInput: false,
                        defaultDate: new Date((new Date(selectedDate)).getTime() + 60*60*1000),
                    })
                }
                
                // update max date for booking end time
                if (booking_end_time.length && selectedDate) {
                    const startDate = new Date(selectedDate);
                    const endOfMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
                    if (booking_end_time[0] && booking_end_time[0]._flatpickr) {
                        booking_end_time[0]._flatpickr.set('maxDate', endOfMonth);
                    }
                }
            },
        });
    }
    if (end_time.length) {
        end_time.flatpickr({
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            minDate: "today",
            allowInput: false,
        });
    }

    // workout form
    let session_type_id = $("select[name='session_type_id']");
    if (session_type_id.length) {
        let limit_form = $("input[name='limit']");
        let point_cost_form = $("input[name='point_cost']");
        session_type_id.on("change", function() {
            let limit = $(this).find(':selected').data('limit');
            if (limit_form.length) {
                limit_form.val(limit);
            }

            let point_cost = $(this).find(':selected').data('point');
            if (point_cost_form.length) {
                point_cost_form.val(point_cost);
            }
        })
    }

    // block address
    if ($('select[name="province_id"]').length) {
        let districtUrl = "/api/address/district";
        let wardUrl = "/api/address/ward";
        $('select[name="province_id"]').on("change", function() {
            let country_id = $(this).val();
            if (country_id) {
                $.ajax({
                    url: districtUrl + "/" + country_id,
                    method: 'GET',
                    success: function(data) {
                        $("select[name='district_id'").html('');
                        $("select[name='ward_id'").html('');
                        $("select[name='district_id']").append(
                            "<option value=''>Choose one</option>"
                        );
                        $.each(data.data.districts, function(key, value){
                            $("select[name='district_id']").append(
                                "<option value=" + value.id + ">" + value.name + "</option>"
                            );
                        });
                    },
                })
            } else {
                $("select[name='district_id'").html('');
                $("select[name='ward_id'").html('');
            }
        });
        $('select[name="district_id"]').on("change", function() {
            let district_id = $(this).val();
            if (district_id) {
                $.ajax({
                    url: wardUrl + "/" + district_id,
                    method: 'GET',
                    success: function(data) {
                        $("select[name='ward_id'").html('');
                        $.each(data.data.wards, function(key, value){
                            $("select[name='ward_id']").append(
                                "<option value=" + value.id + ">" + value.name + "</option>"
                            );
                        });
                    }
                })
            } else {
                $("select[name='ward_id'").html('');
            }
        });
    }
});
